/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 09/11/21
 */

import { Td, Tr } from '@chakra-ui/react';
import React from 'react';
import { namedMemo } from '@/utils/namedMemo';

export interface EmptyTableProps {
    numColumns: number;
    tableName?: string;
}

const ChakraEmptyTable = namedMemo('ChakraEmptyTable', ({ numColumns, tableName }: EmptyTableProps) => (
    <Tr>
        <Td colSpan={numColumns}>No {tableName ?? 'data'}</Td>
    </Tr>
));

export default ChakraEmptyTable;
